import React from "react";
import { Check } from "lucide-react";

const Stepper = ({ currentStep = 5, selectedDate, booking }) => {
  const steps = [1, 2, 3];

  return (
    <div className="w-full bg-dry px-6 py-4 rounded-md flex items-center justify-between">
      {/* LEFT: STEPS */}
      <div className="flex items-center gap-3">
        {steps.map((step) => {
          const isDone = step < currentStep;
          const isActive = step === currentStep;

          return (
            <div
              key={step}
              className={`
                w-7 h-7 rounded-full flex items-center justify-center
                text-xs font-semibold
                ${
                  isDone
                    ? "bg-green-500 text-white "
                    : isActive
                      ? " animate-neonFlicker text-white border bg-neonYellow border-border"
                      : "bg-none border border-border text-gray-300"
                }
              `}
            >
              {isDone ? <Check size={14} /> : step}
            </div>
          );
        })}
      </div>

      {/* RIGHT: TOTAL */}
      <div className="text-right">
        <p className="text-xs text-gray-400">
          {!selectedDate ? "Selecte a Date" : "Booking"}
        </p>

        <p className="text-sm font-semibold text-neonYellow">
          {selectedDate && (
            <span>
              {selectedDate.toLocaleDateString("en-NZ", {
                day: "2-digit",
                month: "short",
              })}
            </span>
          )}

          {booking.persons > 0 && (
            <span className="opacity-80"> · {booking.persons}p </span>
          )}

          {booking.time && <span className="opacity-80">· {booking.time}</span>}
        </p>
      </div>
    </div>
  );
};

export default Stepper;
